export default __webpack_public_path__ + "static/media/hm-net-img.ec64e30b.webp";